'use client'
import React from 'react'

interface TimelineEventPrefixProps {
    prefix?: React.ReactNode
}

export const TimelineEventPrefix = ({ prefix = null }: TimelineEventPrefixProps): JSX.Element => {
    const heightClasses = prefix ? 'w-6 h-6' : 'w-5 h-5'

    return (
        <div className={`timeline-item__prefix ${heightClasses}`}>
            {prefix && prefix}
            {!prefix && <span className="inline-block bg-timeline-dot w-2 h-2 m-auto rounded-full" />}
        </div>
    )
}
